import { render } from "./OnlineOrderReceiptComponent.vue?vue&type=template&id=266f6998"
import script from "./OnlineOrderReceiptComponent.vue?vue&type=script&lang=js"
export * from "./OnlineOrderReceiptComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/onlineOrders/OnlineOrderReceiptComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "266f6998"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('266f6998', __exports__)) {
    api.reload('266f6998', __exports__)
  }
  
  module.hot.accept("./OnlineOrderReceiptComponent.vue?vue&type=template&id=266f6998", () => {
    api.rerender('266f6998', render)
  })

}


export default __exports__